import { shallowRef } from 'vue';
import offers from '@/config/offers.js';
import { isIframe } from '@/form/helpers/iframe-config.js';

/**
 * Whether an offer may show in this context. On the site every offer can. In the
 * embeddable iframe an offer must opt in with `iframe: true`: the existing modals
 * (Credique) call session/CSRF `/portal/*` routes, which a partner-site iframe has
 * no session for. Such an offer only needs stateless endpoints and the flag to be
 * offered in the iframe too.
 *
 * @param {object} offer
 * @param {boolean} [embedded] defaults to isIframe()
 * @returns {boolean}
 */
export function offerAvailableHere(offer, embedded = isIframe()) {
    return !embedded || offer?.iframe === true;
}

export function useOfferCheck() {
    const activeOffer = shallowRef(null);
    const dismissedOffers = new Set();

    function checkOffers(product, stepIndex, app, totalSteps) {
        const matching = offers.filter(
            (offer) => offer.products.includes(product) && offerAvailableHere(offer)
        );

        for (const offer of matching) {
            if (dismissedOffers.has(offer.id)) {
                continue;
            }

            if (typeof offer.conditions === 'function' && !offer.conditions(app, stepIndex, totalSteps)) {
                continue;
            }

            // this delay is to ensure the offer does not show right after a user clicks "Next"
            setTimeout(() => {
                activeOffer.value = offer;
            }, 500);
            return;
        }
    }

    function dismiss() {
        if (activeOffer.value) {
            dismissedOffers.add(activeOffer.value.id);
        }
        activeOffer.value = null;
    }

    return { activeOffer, checkOffers, dismiss };
}
